module.exports = __webpack_public_path__ + "static/media/one-frame.116d95e6.svg";